import { z } from 'zod'
import MindsetDtoSchema from './MindsetEntityDtoSchema'

export namespace MindsetDto {
   export const entitySchema = MindsetDtoSchema
   export type entity = z.output<typeof MindsetDtoSchema>

   export type list = (MindsetDto.entity & { imageFileUrl?: string })[]
   export type listItem = MindsetDto.list[number]

   export const editSchema = MindsetDto.entitySchema.pick({
      name: true,
      categoryIcon: true,
      categories: true,
      description: true,
      imageFileName: true,
      videoUrl: true,
      orgId: true,
      id: true,
   })
   export type edit = z.output<typeof editSchema>

   export const removeSchema = MindsetDto.entitySchema.pick({
      orgId: true,
      id: true,
   })
   export type remove = z.output<typeof removeSchema>

   export const addSchema = MindsetDto.entitySchema.pick({
      name: true,
      categoryIcon: true,
      categories: true,
      description: true,
      imageFileName: true,
      videoUrl: true,
   })
   export type add = z.output<typeof addSchema>
}
